
/* eslint-disable @typescript-eslint/no-unused-vars */
import { computed, ref, inject } from 'vue'
import { useStore } from 'vuex'
import ConfigurationConst from '../../../../../common/domain/constantes/ConfigurationConst'
import Environment from '@ilinium/shared/src/common/domain/constantes/environment'

export default {
  name: 'forgotPassword',
  props: ['isForgetPassChild'],
  emits: ['update:isForgetPassChild'],
  setup (props, context) {
    const store = useStore()
    const emailControl = ref < HTMLElement | null > (null)
    const emailConfirmControl = ref < HTMLElement | null > (null)
    const emailconfirm = ref('')
    const ipublicPath = inject('publicPath')

    /* const user_req: Partial<Usuario> = {
            email: ''
        };

        const request = ref<forgetPasswordRequest>({
            user: user_req as any,
            remoteApplication: 'Portal',
            remoteIp: '',
            requestedUrl: '',
        }); */

    function validateData () {
      /* if (!validateEmail(request.value.user.email)) {
                MessageService.showMessage(MessageType.Error, 'Error de validación', 'Debe indicar un e-mail válido.');
                return false;
            }
            if (request.value.user.email != emailconfirm.value) {
                MessageService.showMessage(MessageType.Error, 'Error de validación', 'Las direcciones de e-mail no coinciden.');
                return false;
            }
*/
      return true
    }

    /* function validateEmail (email) {
      return HelperCommon.validarEmail(email)
    } */

    const onSubmitForgotPassword = () => {
      // Clear existing errors
      if (validateData()) {
        // Dummy delay        
        // Send resetPassword request
        /* store.dispatch(Actions.FORGOT_PASSWORD, request.value).then(() => {
                        MessageService.showToast(MessageType.Correcto, '', 'Se ha enviado el correo de reestablecimiento de contraseña correctamente.');
                        context.emit('update:isForgetPassChild');
                        //router.push({ name: 'forgotpassword' });
                    }).finally(() => {
                        HelperLoading.hideLoading();
                    }); */
      }
    }

    const getLogoUrl = computed(() => {
      return Environment.URL_LOGO_PNG;      
    })

    return {
      // srequest,
      emailControl,
      emailConfirmControl,
      emailconfirm,
      onSubmitForgotPassword,
      getLogoUrl,
      ipublicPath
    }
  }
}
